import { Injectable } from '@angular/core';
import { Store, guid } from '@datorama/akita';

export interface CoachProfileState {
	loading: boolean;
}

@Injectable()
export class CoachProfileStore extends Store<CoachProfileState> {
	constructor() {
		super({ loading: true }, { name: `ui-coach-profile-${guid()}` });
	}
}
